import React from 'react';
import AvButton from './design/nedi/AvButton';
import { t } from './i18n';
import './design/atlasVivo/tokens.css';
import './design/atlasVivo/Buttons.css';
import './design/nedi/nediAnatomy.css';

/**
 * Confirmação in-UI (substitui window.confirm) alinhada ao ImportModal.
 * Chrome: Nedi panel radius + AvButton → `<nedi-button>`.
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;
  const confirmText = confirmLabel || t('action.confirm');
  const cancelText = cancelLabel || t('action.cancel');
  return (
    <div
      className="confirm-dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
      data-nedi-anatomy="dialog"
    >
      <div className="confirm-dialog">
        {title ? <h3 id="confirm-dialog-title">{title}</h3> : null}
        <p>{message}</p>
        <div className="confirm-dialog-actions">
          <AvButton type="button" variant="secondary" onClick={onCancel}>
            {cancelText}
          </AvButton>
          <AvButton
            type="button"
            variant={destructive ? 'destructive' : 'primary'}
            onClick={onConfirm}
          >
            {confirmText}
          </AvButton>
        </div>
      </div>
      <style>{`
        .confirm-dialog-overlay {
          position: fixed; inset: 0; z-index: 4000;
          display: flex; align-items: center; justify-content: center;
          background: rgba(0,0,0,0.45);
        }
        .confirm-dialog {
          max-width: 420px; margin: 16px; padding: var(--nedi-component-panel-padding, 20px);
          background: var(--nedi-color-semantic-surface, var(--av-surface, #1a1c1e));
          color: var(--nedi-color-semantic-textPrimary, var(--av-text, #f5f5f5));
          border-radius: var(--nedi-radius-panel, 28px);
          border: 1px solid color-mix(in srgb, var(--nedi-color-primitive-glassStrokeBlue, #8ca8b4) 30%, transparent);
        }
        .confirm-dialog-actions {
          display: flex; gap: 8px; justify-content: flex-end; margin-top: 16px;
        }
      `}</style>
    </div>
  );
}
